import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

interface KnowledgeCardLinkClickProps extends commonAttributesType {
	location: string;
	position?: number;
	shownAfterCardBodyExpanded?: boolean;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
}

export const onKnowledgeCardLinkClick = (
	props: KnowledgeCardLinkClickProps,
): AnalyticsEventPayload => {
	const { source, location, position, shownAfterCardBodyExpanded, isAuxClick, isContextMenu } =
		props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCardLink',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			location,
			position,
			shownAfterCardBodyExpanded,
			isAuxClick,
			isContextMenu,
		},
	};
};
